import { render } from "./invoice-settings.vue?vue&type=template&id=8040af86"
import script from "./invoice-settings.vue?vue&type=script&lang=js"
export * from "./invoice-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__